import { render, staticRenderFns } from "./PlanejamentoEstrategico.vue?vue&type=template&id=d10d2848&scoped=true"
import script from "./PlanejamentoEstrategico.vue?vue&type=script&lang=js"
export * from "./PlanejamentoEstrategico.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoEstrategico.vue?vue&type=style&index=0&id=d10d2848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10d2848",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
